module.exports = __webpack_public_path__ + "static/img/surAlert.eaed647.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surAlert.png
// module id = DtbO
// module chunks = 1